module.exports = __webpack_public_path__ + "media/images/supplier-locating-icon-f2e3638e2ca49fd436d759a9909d5e32.png";